<div class="quotation-preview">
  <ion-card class="ion-margin">
    <!-- intestazione -->
    <ion-card-header class="ion-text-center">
      <ion-card-title [attr.aria-label]="'quotation_check_title' | ariaLabel | translate">{{'lbl.quotation_check_title' | translate}}</ion-card-title>
      <ion-card-subtitle [attr.aria-label]="'quotation_check_message' | ariaLabel | translate: ({customerName: customerName })">{{'lbl.quotation_check_message' | translate: ({customerName: customerName })}}</ion-card-subtitle>
    </ion-card-header>

    <ion-card-content>
      <!-- visualizzazione normale -->
      <div *appIfView="'QUO_PREV_STD'" class="quotation-preview-standard ion-margin-top">
        <ion-grid class="ion-no-padding ion-no-margin">
          <ng-container *ngFor="let item of primaryData; let index = index">
            <ion-row class="quotation-preview-row">
              <ion-col size-xs="4" size-sm="5" class="quotation-preview-left quotation-preview-labels" [ngClass]="{
                'quotation-preview-labels--bold': item.bold
              }">
                <h5 class="ion-no-margin quotation-preview-labels__title">
                  {{ item.title | translate | uppercase }}
                </h5>
                <div class="quotation-preview-labels__unit">
                  <ng-container [ngSwitch]="item.format">
                    <small *ngSwitchCase="'currency'">{{ 'lbl.euro' | translate }}</small>
                    <small *ngSwitchCase="'perc'">{{ 'lbl.perc_symbol' | translate }}</small>
                    <small *ngSwitchCase="'month'">{{ 'lbl.months' | translate }}</small>
                  </ng-container>
                </div>
              </ion-col>
              <ion-col size-xs="8" size-sm="7" class="quotation-preview-right quotation-preview-value">
                <h1 class="ion-no-margin nice-amount" [ngClass]="{'nice-amount--relevant': index === 0}" [ngSwitch]="item.format">
                  <ng-container *ngSwitchCase="'currency'">
                    <span>{{(item.value | intNumber) + ','}}</span>
                    <span class="decimal">{{item.value | decimalNumber}}</span>
                  </ng-container>
                  <ng-container *ngSwitchCase="'perc'">
                    <span>{{(item.value | intNumber) + ','}}</span>
                    <span class="decimal">{{item.value | decimalNumber}}</span>
                  </ng-container>
                  <ng-container *ngSwitchCase="'month'">
                    <span>{{ item.value | number:'1.0-0' }}</span>
                  </ng-container>
                  <ng-container *ngSwitchDefault>
                    <span>{{(item.value | intNumber) + ','}}</span>
                    <span class="decimal">{{item.value | decimalNumber}}</span>
                  </ng-container>
                </h1>
              </ion-col>
            </ion-row>
            <ion-row class="quotation-preview-row quotation-preview-row--tooltip" *ngIf="!!item.tooltip">
              <ion-col size-xs="4" size-sm="5" class="quotation-preview-left quotation-preview-tooltip">
                <ion-icon size="small" color="primary" [src]="'information' | srcAssets"></ion-icon>
              </ion-col>
              <ion-col size-xs="8" size-sm="7" class="quotation-preview-right quotation-preview-tooltip">
                <small>{{item.tooltip|translate}}</small>
              </ion-col>
            </ion-row>
          </ng-container>
        </ion-grid>

        <ion-button *ngIf="editable" class="quotation-preview-edit-btn" fill="clear" expand="block" (click)="onEdit()">
          <ion-icon slot="start" name="create-outline"></ion-icon>
          {{'btn.quotation_edit'|translate}}
        </ion-button>
      </div>

      <!-- visualizzazione compatta -->
      <div *appIfView="'QUO_PREV_CMP'" class="quotation-preview-compact ion-margin-top">
        <div class="quotation-amount">
          <span>{{primaryData[0].title | translate}}</span>
          <h1>{{primaryData[0].value | dynamicNumber:primaryData[0].format}}</h1>
        </div>
        <div class="quotation-data">
          <ng-container *ngFor="let item of primaryData|slice:1; let index = index">
            <br *ngIf="index > 0 && index % 2 === 0">
            <span class="quotation-data-title">{{item.title | translate}}&nbsp;</span>
            <strong class="quotation-data-value">{{item.value | dynamicNumber:item.format}}&nbsp;</strong>
          </ng-container>
        </div>
        <!-- preammortamento non incluso -->
        <div *ngIf="hasPreAmortizationActive && !hasPreAmortizationIncluded" class="quotation-preview-preamortization">
          <ion-icon [src]="'preamortization_excluded' | srcAssets: 'icons'"></ion-icon>
          <span>{{('lbl.preamortization_excluded')|translate}}</span>
        </div>
        <!-- preammortamento incluso -->
        <div *ngIf="hasPreAmortizationActive && hasPreAmortizationIncluded" class="quotation-preview-preamortization preamortization-included" (click)="openPreamortizationTooltip()">
          <ion-icon [src]="'preamortization_included' | srcAssets: 'icons'"></ion-icon>
          <span>{{('lbl.preamortization_included')|translate}}</span>
        </div>
        <!-- cpi non inclusa -->
        <div *ngIf="hasCpiActive && !hasCpiInlcuded" class="quotation-preview-preamortization">
          <ion-icon [src]="'cpi_excluded'| srcAssets: 'icons'"></ion-icon>
          <span>{{('lbl.cpi_excluded')|translate}}</span>
        </div>
         <!-- cpi inclusa -->
         <div *ngIf="hasCpiActive &&  hasCpiInlcuded" class="quotation-preview-preamortization cpi-included">
          <ion-icon [src]="'cpi_included'| srcAssets: 'icons'"></ion-icon>
          <span>{{('lbl.cpi_included')|translate}}</span>
        </div>
        <ion-button *ngIf="editable"
          [attr.aria-label]="'btn.quotation_modify' | ariaLabel | translate"
          class="quotation-preview-edit-btn"
          fill="clear"
          (click)="onEdit()">
         <ion-icon slot="icon-only" [src]="'pen' | srcAssets:'icons'"></ion-icon>
       </ion-button>
      </div>
    </ion-card-content>
  </ion-card>

  <!-- dettagli visualizzati come frase -->
  <div class="ion-text-center" *ngIf="detailsText">
    <p [attr.aria-label]="ariaDetailsText | translate" class="ion-margin" [innerHTML]="detailsText"></p>
  </div>

  <!-- avviso su ricalcolo -->
  <div *ngIf="updatedAfterText" class="ion-margin ion-text-center">
    <p><ion-text color="secondary">{{updatedAfterText}}</ion-text></p>
  </div>

  <!-- bottone dettagli -->
  <div class="ion-margin ion-text-center">
    <ion-button
      [attr.aria-label]="'btn_quotation_preview_details' | ariaLabel | translate"
      size="small"
      fill="clear"
      class="overview-details-btn"
      (click)="openDetailsModal()">
      {{ 'btn.quotation_details' | translate }}
      <ion-icon name="chevron-forward-outline"></ion-icon>
    </ion-button>
  </div>
</div>

